/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DemandeInscriptionGridDto } from './DemandeInscriptionGridDto';
import {
    DemandeInscriptionGridDtoFromJSON,
    DemandeInscriptionGridDtoFromJSONTyped,
    DemandeInscriptionGridDtoToJSON,
} from './DemandeInscriptionGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DemandeInscriptionGridDtoPaginatedResults
 */
export interface DemandeInscriptionGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DemandeInscriptionGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DemandeInscriptionGridDto>}
     * @memberof DemandeInscriptionGridDtoPaginatedResults
     */
    results?: Array<DemandeInscriptionGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DemandeInscriptionGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DemandeInscriptionGridDtoPaginatedResults interface.
 */
export function instanceOfDemandeInscriptionGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DemandeInscriptionGridDtoPaginatedResultsFromJSON(json: any): DemandeInscriptionGridDtoPaginatedResults {
    return DemandeInscriptionGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DemandeInscriptionGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DemandeInscriptionGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DemandeInscriptionGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DemandeInscriptionGridDtoPaginatedResultsToJSON(value?: DemandeInscriptionGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DemandeInscriptionGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

